import React from 'react';
import { Card } from 'bumbag';
import _get from 'lodash/get';

import { withRouter } from '@medipass/react-core/router';
import sdk from '@medipass/web-sdk';

import Page from 'legacy/components/account/layout/Page';
import PaymentMethodForm from 'legacy/components/account/payment-methods/PaymentMethodForm';
import WithAuthentication from 'legacy/components/WithAuthentication';
type Props = {
  history: (...args: Array<any>) => any;
};

class CreatePaymentMethod extends React.PureComponent<Props> {
  handleAddPaymentMethod = async ({ nonce, source }: { nonce: string; source: string }) => {
    const { history } = this.props;

    const accountId = _get(sdk, 'account._id');

    const paymentMethod = await sdk.payments.createAccountPaymentMethod(accountId, nonce, source);
    // @ts-expect-error TS(2339): Property 'push' does not exist on type '(...args: ... Remove this comment to see the full error message
    history.push('/account/payment-methods/');
    return paymentMethod;
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="Add a payment method">
        <Card>
          <PaymentMethodForm onSubmit={this.handleAddPaymentMethod} title="Add a payment method" />
        </Card>
      </Page>
    </WithAuthentication>
  );
}

export default withRouter(CreatePaymentMethod);
